import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get, post } from '~/actions/base'
import { showUndoMessage } from '~/actions/snackbar'
import { Button, Card, Divider, List } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { push } from 'react-router-redux'
import TagListItem from './TagListItem'
import RightPanelContent from '../Layout/RightPanelContent'

class TagPanel extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      tags: null,
      isLoaded: false
    }
  }

  // MIGRATED TO componentDidMount
  // componentWillMount () {
  //   this.fetchAllData()
  // }

  componentDidMount() {
    if (this.state.isLoaded === false) {
      this.fetchAllData()
    }
  }

  fetchAllData() {
    this.fetchTags()
  }

  fetchTags() {
    this.props.get('tag/list', {
      onSuccess: (response) => {
        this.setState({
          isLoaded: true,
          tags: response.TagList
        })
      }
    })
  }

  addNewItem() {
    const newItem = {
      TagName: ''
    }

    const newTags = this.state.tags.concat(newItem)

    this.setState({ tags: newTags })
  }

  deleteTag(index, item) {
    const { language } = this.context
    const body = JSON.stringify({})

    if (!item.ID) {
      const { tags } = this.state
      tags.splice(index, 1)

      this.setState({ tags })
    } else {
      this.props.post(`tag/${item.ID}/delete`, body, {
        onSuccess: (response) => {
          this.fetchTags()

          this.props.showUndoMessage(
            language.translate('application.tagRemoved'),
            () => {
              this.props.post(`tag/${item.ID}/delete/undo`, body, {
                onSuccess: (response) => {
                  this.fetchTags()
                }
              })
            }
          )
        }
      })
    }
  }

  saveTag(index, tag) {
    const { tags } = this.state
    const endpoint = (!tag.ID) ? 'tag' : `tag/${tag.ID}`

    const body = JSON.stringify({
      Tag: tag
    })

    this.props.post(endpoint, body, {
      onSuccess: (response) => {
        tags[index] = response.Tag

        this.setState({ tags })
      }
    })
  }

  render() {
    const { language } = this.context
    const { isLoaded, tags } = this.state

    return (
      <RightPanelContent
        closePanel={() => this.props.close()}
        title={language.translate('application.accountTags')}
      >
        {(isLoaded)
          ? <div style={{ padding: '15px' }}>
            <Card className='card'>
              <List style={{ padding: '0px' }}>
                {tags.map((tag, index) => (
                  React.Children.toArray([
                    <TagListItem
                      key={tag.ID || index}
                      item={tag}
                      deleteTag={tag => this.deleteTag(index, tag)}
                      onSave={tag => this.saveTag(index, tag)}
                    />,
                    (index < tags.length - 1) ? <Divider key={`${tag.ID}-div`} /> : null
                  ])
                ))}
              </List>
            </Card>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
              <Button
                onClick={this.addNewItem.bind(this)}
                color='primary'
                variant='contained'
              >
                <Add />
                {language.translate('application.createNewTag')}
              </Button>
            </div>
          </div>
          : null}
      </RightPanelContent>
    )
  }
}

TagPanel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  post: PropTypes.func.isRequired,
  get: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  showUndoMessage: PropTypes.func.isRequired
}

TagPanel.contextTypes = {
  location: PropTypes.object,
  language: PropTypes.object,
  muiTheme: PropTypes.object
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  dispatch,
  post: bindActionCreators(post, dispatch),
  get: bindActionCreators(get, dispatch),
  push: bindActionCreators(push, dispatch),
  showUndoMessage: bindActionCreators(showUndoMessage, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(TagPanel)
